import { selectorFamily, waitForAll } from 'recoil';
import { getCoverageRequestItems } from '../../utils/coverablesUtil';
import { singleHippoCoverageTextSelector } from './singleHippoCoverageTextSelector';

const hippoCoverageTextsSelector = selectorFamily({
    key: 'hippoCoverageTextsSelector',
    get:
        ({ coverageIds, termIds }: { coverageIds: string[]; termIds: string[] }) =>
        ({ get }) => {
            if (!coverageIds) return [];
            const requestItems = getCoverageRequestItems(termIds, coverageIds);
            if (requestItems.length === 0) return [];

            const coverageTextItems = get(
                waitForAll(requestItems.map(singleHippoCoverageTextSelector))
            ).flat(1);

            return coverageTextItems;
        }
});

export { hippoCoverageTextsSelector };
